module.exports = __webpack_public_path__ + "static/howitworks-cebafe0fad7461af739236aa739709eb.jpg";